<template>
  <v-modal
    v-model="show"
    :id-content="'sl-dialog-loader'"
    :prevent-click="true"
    :focus-retain="true"
    :confirm-action="false"
    :cancel-action="false"
    :close-action="false"
    :attach="attach"
    name="sl-dialog-loader"
    data-cy="sl-dialog-loader"
    @confirm="confirm"
    @cancel="cancel"
  >
    <template #title>
      {{ title }}
    </template>
    <SlLoader />
  </v-modal>
</template>

<script>
import SlLoader from "src/modules/shared/components/SlLoader";
export default {
  components: {SlLoader},
  props: {
    title: {
      type: String,
      default: ''
    },
    attach: {
      default: false
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    confirm() {
      // some code...
    },
    cancel(close) {
      // some code...
      close()
    }
  }
}
</script>

